import { ReactNode } from "react";
import casino from "./../../_asset/image/title/casino.png";
import slot from "./../../_asset/image/title/slot.png";
import { gameTypes } from "../list/game_list";

export default function SectionHeader({sectionType}: {sectionType: gameTypes}){
    return (
        <header className="section-header">
            <img src={sectionType == 'casino' ? casino : slot} alt="" />
        </header>
    )
}
